import { FetchAPI } from "@renedelangel/helpers";
import { urlServidor } from '../../helpers';

const CAMPOS = `
    seguimientoSemanalSegID
    seguimientoSeguroID
    comentario
    avance
    fechaSeguimiento
    personalSeguimiento
    usuarioID
    usuario
    altaSeguimiento
    seguimientoProgramaID
    seguimientoPrograma
    avancePrograma
`;

//PARA EL GET:

export const GET_SEGUIMIENTOSEMANALSEG = `
query get($filtro: InputGetSeguimientoSemanalSeg){
    getSeguimientoSemanalSeg(filtro:$filtro){
        ${CAMPOS}
    }
}
`;

//PARA EL GET ALL:

export const GET_ALL_SEGUIMIENTOSEMANALSEG = `
query filtroGetAll($filtro: InputGetSeguimientoSemanalSeg){
    getAllSeguimientoSemanalSeg(filtro: $filtro){
        ${CAMPOS}
    }
}
`;

//PARA LA TABLA:

export const TABLA_SEGUIMIENTOSEMANALSEG = `
query filtro($filtro: InputFilterSeguimientoSemanalSeg){
    filterSeguimientoSemanalSeg(filtro: $filtro){
        listado{
            ${CAMPOS}
        }
        registros
        paginas
    }
}
`;

// Seguimientos del Programa Anual de la tarea de la que viene el seguimiento padre: [{ value, label }]
export const seleccionSeguimientosPrograma = async (seguimientoSeguroID, token) => {
    let { getSeguimientosProgramaSemanalSeg } = await FetchAPI.graphql({
        token,
        variables: { seguimientoSeguroID },
        url: urlServidor,
        query: `query programa($seguimientoSeguroID: ID){
            getSeguimientosProgramaSemanalSeg(seguimientoSeguroID: $seguimientoSeguroID){ seguimientoProgramaID seguimientoPrograma }
        }`
    });
    return (getSeguimientosProgramaSemanalSeg || []).map(({ seguimientoProgramaID, seguimientoPrograma }) => ({ value: String(seguimientoProgramaID), label: seguimientoPrograma }));
}

export const getSeguimientoSemanalSeg = async (filtro, token) => {
    try {
        let { getSeguimientoSemanalSeg } = await FetchAPI.graphql({
            token,
            variables: { filtro },
            url: urlServidor,
            query: GET_SEGUIMIENTOSEMANALSEG
        });
        return getSeguimientoSemanalSeg;
    } catch ({ message }) { throw new Error(message); }
}

export const getAllSeguimientoSemanalSeg = async (variables, token) => {
    try {
        let { getAllSeguimientoSemanalSeg } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: GET_ALL_SEGUIMIENTOSEMANALSEG
        });
        return getAllSeguimientoSemanalSeg;
    } catch ({ message }) { throw new Error(message); }
}

export const tablaSeguimientoSemanalSeg = async (variables, token) => {
    try {
        let { filterSeguimientoSemanalSeg } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: TABLA_SEGUIMIENTOSEMANALSEG
        });
        return filterSeguimientoSemanalSeg;
    } catch ({ message }) { throw new Error(message); }
}
